var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3.4873C5.915 3.4873 2.9975 6.4048 2.9975 9.9898C2.9975 13.5748 5.915 16.4998 9.5 16.4998C13.085 16.4998 16.0025 13.5823 16.0025 9.9973C16.0025 6.4123 13.085 3.4873 9.5 3.4873ZM10.0625 9.7498C10.0625 10.0573 9.8075 10.3123 9.5 10.3123C9.1925 10.3123 8.9375 10.0573 8.9375 9.7498V5.9998C8.9375 5.6923 9.1925 5.4373 9.5 5.4373C9.8075 5.4373 10.0625 5.6923 10.0625 5.9998V9.7498Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6675 2.5875H7.3325C7.0325 2.5875 6.7925 2.3475 6.7925 2.0475C6.7925 1.7475 7.0325 1.5 7.3325 1.5H11.6675C11.9675 1.5 12.2075 1.74 12.2075 2.04C12.2075 2.34 11.9675 2.5875 11.6675 2.5875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.ca7c117cb9f12bb9525a4a4dc49c9766.svg";
export { ForwardRef as ReactComponent };